var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PropertyService } from './../api/property.service';
import { AgencyService } from './../api/agency.service';
import { OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Lightbox, LightboxConfig, LightboxEvent, LIGHTBOX_EVENT } from 'angular2-lightbox';
import { BaseComponent } from './base-component';
import { GoogleMapComponent } from '../gmaps/google-map/google-map.component';
var HouseDetailsBaseComponent = /** @class */ (function (_super) {
    __extends(HouseDetailsBaseComponent, _super);
    function HouseDetailsBaseComponent(injector, route, agencyService, propertyService, _lightbox, _lightboxEvent, _lighboxConfig, window, document) {
        var _this = _super.call(this, injector) || this;
        _this.route = route;
        _this.agencyService = agencyService;
        _this.propertyService = propertyService;
        _this._lightbox = _lightbox;
        _this._lightboxEvent = _lightboxEvent;
        _this._lighboxConfig = _lighboxConfig;
        _this.window = window;
        _this.document = document;
        _this.type = 'house';
        return _this;
    }
    HouseDetailsBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.data.forEach(function (data) {
            if (data.property) {
                _this.validateRouteDataParams(data, ['property']);
                _this.property = data.property;
                _this.item = data.property;
                _this.item.latitude = _this.property.website_latitude;
                _this.item.longitude = _this.property.website_longitude;
                _this.characteristics = _this.propertyService.generateCharacteristicsString(_this.property);
                _this.initLightbox(_this.property.images);
                _this.setTitle(_this.property.title + (_this.property.project && _this.property.project.name ? ' - ' + _this.property.project.name : ''));
                _this.setMetaDescription(_this.property.description);
            }
        });
        var promise = this.propertyService.getPromoProperties();
        if (promise) {
            promise.then(function (properties) {
                _this.promoProperties = properties;
            });
        }
    };
    HouseDetailsBaseComponent.prototype.open = function (index) {
        var _this = this;
        if (this.window) {
            this._lighboxConfig.positionFromTop = 20;
        }
        this._subscription = this._lightboxEvent.lightboxEvent$.subscribe(function (event) { return _this._onReceivedEvent(event); });
        this._lightbox.open(this._albums, index, { wrapAround: true, showImageNumberLabel: true });
    };
    HouseDetailsBaseComponent.prototype._onReceivedEvent = function (event) {
        if (event.id === LIGHTBOX_EVENT.CLOSE) {
            if (this._subscription) {
                this._subscription.unsubscribe();
            }
        }
    };
    HouseDetailsBaseComponent.prototype.initLightbox = function (images) {
        this._albums = [];
        for (var _i = 0, images_1 = images; _i < images_1.length; _i++) {
            var image = images_1[_i];
            var album = {
                src: image.url,
                caption: image.description,
                thumb: image.width_560_url
            };
            this._albums.push(album);
        }
        this._lighboxConfig.fadeDuration = 1;
    };
    return HouseDetailsBaseComponent;
}(BaseComponent));
export { HouseDetailsBaseComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/house-details-base.component.ts.pre-build-optimizer.js